import { render, staticRenderFns } from "./CCTableTreeSelect.vue?vue&type=template&id=e280ffa2"
import script from "./CCTableTreeSelect.vue?vue&type=script&lang=js"
export * from "./CCTableTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./CCTableTreeSelect.vue?vue&type=style&index=0&id=e280ffa2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports